
import MUIDataTable from 'mui-datatables'
import { Link, withRouter } from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
import "../../../css/Users.css"
import { containsPermission, generateErrorMessage, logOut } from '../../helper';
import React, {Component} from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import { ButtonToolbar } from 'react-bootstrap';
import { ButtonGroup } from 'react-bootstrap';


const columns = [
    {
        "name" : "display_name",
        "label" : "როლი",
        "options": {
            "sort" : true
        }
    },
    
]
class Roles extends Component {
    constructor(props){
        
        super(props);
        this.onRowSelectionChange = this.onRowSelectionChange.bind(this);
        this.toolbarSelect = this.toolbarSelect.bind(this)
        this.state = {
            data:[],
            selected_role:-1,
            options:{
                filterType: 'checkbox',
                selectableRowsHeader:false,
                expandableRowsHeader:false,
                viewColumns:false,
                print:false,
                filter:false,
                selectableRows:'single',
                onRowsDelete:this.onRowsDelete,
                onRowSelectionChange:this.onRowSelectionChange,
                customToolbarSelect:this.toolbarSelect,
                rowsSelected:[]
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'პრობლემა წარმატებით ჩაემატა'
            }
        }
        
    }
    componentDidMount(){
        this.fetch_roles();
    }

    onRowSelectionChange(currentRowsSelected){
        this.setState({
            ...this.state,
            selected_role:this.state.data[currentRowsSelected[0].dataIndex].id,
            response:{
                isInvalid:false,
                isValid:false
            }
        })
    }
    

    update_btn_clicked(){
        this.props.history.push("/roles/update_role/"+this.state.selected_role)
    }

    delete_btn_clicked(){
        axiosInstance.delete('/roles/'+this.state.selected_role)
        .then(response=>this.on_role_deleted(response.data))
        .catch(error => {
            if(error.response.status == 422 ||error.response.status==503){
                this.on_bad_request(error);
            }
        });

        return false;
    }


    toolbarSelect(){
        return (
            <ButtonToolbar> 
                    <ButtonGroup  className="mr-2">
                        <Button className = "btn-warning"  onClick = {(e)=>this.update_btn_clicked()}>შეცვლა</Button>
                    </ButtonGroup>
                    <ButtonGroup className="mr-2">
                        <Button className = "btn-danger"  onClick = {(e)=>this.delete_btn_clicked()}>წაშლა</Button>
                    </ButtonGroup>
            </ButtonToolbar>
        )
    }

    fetch_roles(){
        axiosInstance.get('/roles')
        .then(response=>this.on_fetch_roles(response.data.data))
        .catch(err => {
            if(err.response !== null){
                if(err.response.status === 401){
                    logOut(this.props);
                }
            }
        })
    }

    on_fetch_roles(data){
        let roles_array = [];
        data.forEach(element => {
            roles_array.push({
                "id" : element.id,
                "display_name" : element.display_name
            })
        });
        this.setState({
            data:roles_array
        });
    }
    on_role_deleted(data){
        this.fetch_roles();
        this.setState({
            response:{
                ...this.state.response,
                isValid:true,
                message:data.message
            },
            options:{
                ...this.state.options,
                rowsSelected:[]
            },
        })
    }

    on_bad_request(error){
        let message = generateErrorMessage(error.response.data.errors);
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:message
            }
        })
    }


    render(){

        let add_role = null;
        if(containsPermission(this.props.role_permissions,'roles.add')){
            add_role = <Link  to = "/roles/new_role"  id = "create_new_btn" className="btn btn-dark" > ახლის დამატება</Link>;
        }
        return (
            <div className = "content-main">
                 <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    problem="text"
                                    name="problem"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                {add_role}
                <MUIDataTable
                    data={this.state.data}
                    columns={columns}
                    options={this.state.options}
                />
            </div>
        )
    }
}
export default withRouter(Roles);